import BR from 'assets/images/flags/br.svg?react';
import ENCA from 'assets/images/flags/ca.svg?react';
import CAFR from 'assets/images/flags/ca.svg?react';
import DE from 'assets/images/flags/de.svg?react';
import ES from 'assets/images/flags/es.svg?react';
import FR from 'assets/images/flags/fr.svg?react';
import GB from 'assets/images/flags/gb.svg?react';
import EN from 'assets/images/flags/global.svg?react';
import ESGlobal from 'assets/images/flags/global.svg?react';
import PT from 'assets/images/flags/pt.svg?react';
import IT from 'assets/images/flags/it.svg?react';

const langs = {
  global: EN,
  'en-US': EN,
  'es-419': ESGlobal,
  'es-ES': ES,
  'fr-FR': FR,
  'de-DE': DE,
  'pt-PT': PT,
  'pt-BR': BR,
  'en-CA': ENCA,
  'fr-CA': CAFR,
  'en-GB': GB,
  'it-IT': IT,
};

export default langs;
